// extracted by mini-css-extract-plugin
export default {"planCardStandard":"planCards-module_planCardStandard_a_OMyk5i4o","planCardFamily":"planCards-module_planCardFamily_ViwBwaoh29"};